<!--
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2024-09-02 09:14:23
 * @LastEditors: szj
 * @LastEditTime: 2025-12-12 13:56:07
-->
<template>
  <a-modal v-model:visible="planVisible" :maskClosable="false" centered :width="waylinetaskwidth"
    :title="!isEdit ? '新增计划' : '编辑计划'" @ok="onSubmit" @cancel="closePlan(false)">
    <div class="create-plan-wrapper">
      <div class="content">
        <div class="contentL">
          <a-form ref="valueRef" layout="horizontal" :rules="rules" :model="planBody" labelAlign="left">
            <a-form-item label="计划名称" name="name">
              <a-input placeholder="请输入计划名称" v-model:value="planBody.name" />
            </a-form-item>
            <!-- 航线 -->
            <a-form-item label="飞行航线" :wrapperCol="{ offset: 0 }" name="file_id">
              <div class="flex-row">
                <a-input class="mr-10" placeholder="请选择航线" v-model:value="wayline.name" />
                <div class="selectbtn" @click="selectRoute">
                  选择航线
                  <span class="text-primary">
                    <RightOutlined />
                  </span>
                </div>
              </div>
            </a-form-item>
            <!-- 选择的航线-->
            <a-form-item label="航线" v-if="false && planBody.file_id" class="mt-neg-15">
              <div class="wayline-panel panel-border">
                <div class="title">
                  <div class="pr10 text-ellipsis w-230">
                    {{ wayline.name }}
                  </div>
                </div>
              </div>
            </a-form-item>

            <!--  -->
            <a-form-item v-if="false && planBody.dock_sn" label="设备" class="mt-neg-15">
              <div class="panel panel-border">
                <div class="title">
                  <a-tooltip :title="dock.nickname">
                    <div class="pr10 text-ellipsis w-230">
                      {{ dock.nickname }}
                    </div>
                  </a-tooltip>
                </div>
                <div class="ml10 mt5 text-dark">
                  <span>
                    <RocketOutlined />
                  </span>
                  <!-- <span class="ml5">{{ dock.children?.nickname ?? "无" }}</span> -->
                </div>
              </div>
            </a-form-item>
            <!-- 任务类型 -->
            <a-form-item label="任务定时器" class="plan-timer-form-item">
              <div class="text-nowrap">
                <a-radio-group v-model:value="planBody.task_type" button-style="solid">
                  <a-radio :value="TaskType.Immediate">立即执行</a-radio>
                  <a-radio :value="TaskType.Single">单次定时</a-radio>
                  <a-radio :value="TaskType.Repetitive" v-if="!jobId">重复定时</a-radio>
                </a-radio-group>
              </div>
            </a-form-item>
            <!-- 执行时间 -->
            <a-form-item label="执行时间" class="ml-100" v-if="planBody.task_type === TaskType.Single"
              name="select_execute_time">
              <a-date-picker v-model:value="planBody.select_execute_time" format="YYYY-MM-DD HH:mm:ss" show-time
                placeholder="选择时间" class="w-full" />
            </a-form-item>
            <div class="ml-100" v-if="
              planBody.task_type === TaskType.Repetitive ||
              planBody.task_type === TaskType.Continuous
            ">
              <!-- 执行日期 -->
              <a-form-item label="执行日期" name="select_execute_date">
                <a-range-picker v-model:value="planBody.select_execute_date" format="YYYY-MM-DD"
                  valueFormat="YYYY-MM-DD" placeholder="选择日期" class="w-full" />
              </a-form-item>
              <!-- 执行时间 (重复定时) -->
              <a-form-item label="执行时间" v-if="planBody.task_type === TaskType.Repetitive">
                <div class="time-box" v-for="(item, index) in timeDateArr" :key="index">
                  <a-time-picker v-model:value="timeDateArr[index].time" format="HH:mm" valueFormat="HH:mm"
                    placeholder="选择时间" class="w-300" />
                  <a-tooltip placement="bottom" title="添加">
                    <span class="time-btn" @click="addTimeDate">
                      <PlusCircleOutlined />
                    </span>
                  </a-tooltip>
                  <a-tooltip placement="bottom" title="移出">
                    <span class="time-btn" v-if="index == 0">
                      <MinusCircleOutlined class="text-disabled cursor-not-allowed" />
                    </span>
                    <span class="time-btn" v-else @click="subTimeDate(index)">
                      <MinusCircleOutlined />
                    </span>
                  </a-tooltip>
                </div>
              </a-form-item>
              <!-- 重复频率 -->
              <a-form-item label="重复频率">
                <div class="frequency-box">
                  <span>每</span>
                  <a-input-number v-model:value="planBody.select_execute_num" placeholder="请输入重复频率" class="w-45" />
                  <a-select ref="select" v-model:value="planBody.select_execute_frequency" class="w-45">
                    <a-select-option value="month">月</a-select-option>
                    <a-select-option value="week">周</a-select-option>
                    <a-select-option value="day">天</a-select-option>
                  </a-select>
                </div>
              </a-form-item>
              <a-form-item label="重复规则" v-if="planBody.select_execute_frequency == 'month'">
                <!-- 按日期 -->
                <div class="mt-10">
                  <div class="month-date-box">
                    <div v-for="item in monthDate" :key="item" class="month-date-item">
                      <a-button block @click="selectMonthDate(item)"
                        :type="checkMonthDate.includes(item) ? 'primary' : ''">{{ item }}</a-button>
                    </div>
                  </div>
                </div>
              </a-form-item>
              <a-form-item label="重复规则" v-if="planBody.select_execute_frequency == 'week'">
                <!-- 按周 -->
                <div class="month-date-box">
                  <div v-for="item in weekDate" :key="item" class="month-date-item">
                    <a-button class="p-0" block @click="selectWeekDate(item)"
                      :type="checkWeekDate.includes(item) ? 'primary' : ''">{{ item }}</a-button>
                  </div>
                </div>
              </a-form-item>
            </div>

            <!-- Lost Action -->
            <a-form-item label="失控动作" name="out_of_control_action">
              <div class="text-nowrap">
                <a-radio-group v-model:value="planBody.out_of_control_action" button-style="solid">
                  <a-radio v-for="action in OutOfControlActionOptions" :value="action.value" :key="action.value">
                    {{ action.label }}
                  </a-radio>
                </a-radio-group>
              </div>
            </a-form-item>

            <!-- 设备 -->
            <a-form-item label="默认设备" :wrapperCol="{ offset: 0 }" name="dock_sn">
              <div>
                <a-select ref="select" v-model:value="planBody.dock_sn" class="w-full" placeholder="请选择设备"
                  @change="changeDockType">
                  <a-select-option :value="item.device_sn" v-for="(item, index) in dockList" :key="index">{{
                    item.nickname }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>

            <!-- RTH Altitude Relative to Dock -->
            <a-form-item label="返航高度" name="rth_altitude">
              <div class="flex-row">
                <div class="prompt">
                  <span class="text-warning">
                    <InfoCircleOutlined />
                  </span>
                  <span>
                    当前为系统默认设置，可在输入框中重新自定义。
                  </span>
                </div>
                <a-input v-model:value="planBody.rth_altitude" class="w-100" addon-after="m">
                </a-input>
              </div>
            </a-form-item>
            <a-form-item label="航线精度类型" name="wayline_precision_type">
              <div class="text-nowrap">
                <a-radio-group v-model:value="planBody.wayline_precision_type">
                  <a-radio v-for="action in precisionTypeOption" :value="action.value" :key="action.value">
                    {{ action.label }}
                  </a-radio>
                </a-radio-group>
              </div>
            </a-form-item>
            <a-form-item label="AI设置" name="start_off_line_ai" v-if="config.layout.aiAllFlag">
              <div class="text-nowrap">
                <a-radio-group v-model:value="planBody.start_off_line_ai">
                  <a-radio v-for="action in aiLineOption" :value="action.value" :key="action.value">
                    {{ action.label }}
                  </a-radio>
                </a-radio-group>
              </div>
            </a-form-item>
            <a-form-item label="模型" v-if="planBody.start_off_line_ai == 1">
              <a-select v-model:value="modelList" :options="modelOptions" mode="multiple" placeholder="请选择">
              </a-select>
            </a-form-item>
            <a-form-item label="相机类型" v-if="planBody.start_off_line_ai == 1">
              <div class="text-nowrap">
                <a-checkbox-group v-model:value="cameraList">
                  <a-checkbox value="W" v-if="dockType">广角</a-checkbox>
                  <a-checkbox value="Z" v-if="dockType">变焦</a-checkbox>
                  <a-checkbox value="V" v-if="!dockType">可见光</a-checkbox>
                  <a-checkbox value="T">红外</a-checkbox>
                </a-checkbox-group>
              </div>
            </a-form-item>
            <a-form-item label="飞行备注" name="remark">
              <a-input placeholder="请输入飞行备注" v-model:value="planBody.remark" />
            </a-form-item>
          </a-form>
        </div>
        <div class="shrink-icons" v-if="drawerVisible" @click="closePanel">
          <DoubleLeftOutlined />
        </div>
        <!-- 选择航线 -->
        <div class="contentR" v-if="drawerVisible">
          <div v-if="wayVisible">
            <waylinetaskVue @closeWayline="closePanel" />
          </div>
        </div>

      </div>
    </div>
  </a-modal>
</template>

<script lang="ts">
// @ts-ignore
import waylinetaskVue from "/@/pages/page-web/projects/waylinetask.vue";
import {
  computed,
  defineComponent,
  onMounted,
  watch,
  onUnmounted,
  reactive,
  ref,
  toRaw,
  UnwrapRef,
  defineProps,
  defineEmits,
} from "vue";
import {
  CloseOutlined,
  RocketOutlined,
  CameraFilled,
  UserOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
  RightOutlined,
  InfoCircleOutlined,
  DoubleLeftOutlined,
} from "@ant-design/icons-vue";
import { ELocalStorageKey, ERouterName } from "/@/types";
import { getFlyNum } from "/@/api/sys/sys";
import { useMyStore } from "/@/store";
import { WaylineType, WaylineFile } from "/@/types/wayline";
import { Device, EDeviceType } from "/@/types/device";
import { createPlan, CreatePlan, createPlanEdit } from "/@/api/wayline";
import { getRoot } from "/@/root";
import {
  TaskType,
  OutOfControlActionOptions,
  OutOfControlAction,
  sysType,
} from "/@/types/task";
import moment, { Moment } from "moment";
import { RuleObject } from "ant-design-vue/es/form/interface";
import { getWaylineFiles } from "/@/api/wayline";
import { getBindingDevices } from "/@/api/manage";
import { EDeviceTypeName } from "/@/types";
import { message } from "ant-design-vue";
import { getAimodelApi } from "/@/api/aiApi/ai";
import { pxToRem } from "/@/utils/common";
import { CURRENT_CONFIG as config } from "/@/api/http/config";

export default defineComponent({
  name: "createPlan",
  props: {
    editData: {
      type: String,
    },
    // 弹框
    visible: {
      type: Boolean,
    },
    // 标题
    isEdit: {
      type: Boolean,
    },
  },
  emits: ["closeplan"],
  components: {
    waylinetaskVue,
    CloseOutlined,
    PlusCircleOutlined,
    MinusCircleOutlined,
    RightOutlined,
    InfoCircleOutlined,
    DoubleLeftOutlined,
  },
  setup(props, context) {
    const root = getRoot();
    const store = useMyStore();

    const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId)!;
    const jobId = ref();

    const wayline = computed<WaylineFile>(() => {
      return store.state.waylineInfo;
    });

    const dock = computed<Device>(() => {
      return store.state.dockInfo;
    });

    const disabled = ref(false);
    const waylinetaskwidth = ref(pxToRem(640)); // 弹框宽度
    const planVisible = ref(false);
    const dockList = ref<any>([]); // 机场列表
    const routeName = ref("");
    const planBody = reactive({
      name: "",
      file_id: computed(() => store?.state.waylineInfo.id),
      dock_sn: null,
      task_type: TaskType.Immediate,
      select_execute_time: undefined as Moment | undefined,
      rth_altitude: "",
      wayline_precision_type: 1,
      out_of_control_action: OutOfControlAction.ReturnToHome,
      select_execute_date: undefined as [Moment, Moment] | undefined, //执行日期
      select_execute_date_time: undefined as Moment | undefined, //执行时间
      select_execute_num: 1, //重复次数
      select_execute_frequency: "month", //重复类型
      start_off_line_ai: 0, //开启离线AI
      remark: "", //飞行备注
    });
    // 机场类型 true为机场2、3，false为机场1
    const dockType = ref<any>(false);
    function changeDockType() {
      if (planBody.dock_sn && dockList.value?.length > 0) {
        dockList.value.forEach((item: any) => {
          if (planBody.dock_sn == item.device_sn) {
            if (item.device_name == "DJI Dock") {
              dockType.value = true;
            } else {
              dockType.value = false;
            }
          }
        });
      }
    }
    // 月日期
    const monthDate = ref<any>([]);
    // 周日期
    const weekDate = ref<any>([
      "周日",
      "周一",
      "周二",
      "周三",
      "周四",
      "周五",
      "周六",
    ]);
    const precisionTypeOption = ref([
      {
        value: 0,
        label: "普通任务",
      },
      {
        value: 1,
        label: "高精度 RTK 任务",
      },
    ]);
    const aiLineOption = ref([
      {
        value: 0,
        label: "关闭",
      },
      {
        value: 1,
        label: "全域AI",
      },
      {
        value: 2,
        label: "区域AI",
      },
    ]);
    // 选中的模型
    const modelList = ref<any>([]);
    // 模型下拉
    const modelOptions = ref<any>([]);
    // 选中的离线视频
    const cameraList = ref<any>([]);
    // 选中的月日期
    const checkMonthDate = ref<any>([]);
    // 选中的周日期
    const checkWeekDate = ref<any>([]);
    // 执行时间数组
    const timeDateArr = ref<any>([
      {
        time: undefined as Moment | undefined, //执行时间
      },
    ]);
    // 连续执行时间数组
    const timeDateConArr = ref<any>([
      {
        stime: undefined as Moment | undefined, //执行时间
        etime: undefined as Moment | undefined, //执行时间
      },
    ]);
    const drawerVisible = ref(false);
    const wayVisible = ref(false);
    const valueRef = ref();
    const rules = {
      name: [
        { required: true, message: "请输入计划名称" },
        { max: 20, message: "长度在1 - 20 之间", trigger: "blur" },
      ],
      file_id: [{ required: true, message: "选择航线" }],
      dock_sn: [{ required: true, message: "选择设备" }],
      select_execute_time: [{ required: true, message: "选择开始时间" }],
      rth_altitude: [
        {
          validator: async (rule: RuleObject, value: string) => {
            if (!/^[0-9]{1,}$/.test(value)) {
              throw new Error("请输入返航高度");
            }
          },
        },
      ],
      out_of_control_action: [{ required: true, message: "选择失效动作" }],
    };
    watch(
      () => props.visible,
      (val) => {
        if (val) {
          planVisible.value = true;
        } else {
          planVisible.value = false;
        }
      },
      { deep: true, immediate: true }
    );
    watch(
      () => props.editData,
      async (data) => {
        getDocks();
        getFlyData();
        getModelList();
        if (data) {
          const editList = JSON.parse(data);
          planBody.name = editList.job_name;
          jobId.value = editList.job_id;
          // planBody.file_id = editList.file_id
          planBody.dock_sn = editList.dock_sn;
          planBody.task_type = editList.task_type;
          planBody.rth_altitude = editList.rth_altitude;
          planBody.wayline_precision_type = editList.wayline_precision_type;
          planBody.out_of_control_action = editList.out_of_control_action;
          planBody.select_execute_time = editList.begin_time;
          planBody.start_off_line_ai = editList.start_off_line_ai; // 开启离线AI
          planBody.remark = editList.remark || ""; // 飞行备注
          if (editList.off_line_ai_model) {
            modelList.value = editList.off_line_ai_model.split(",");
          }
          if (editList.off_line_ai_camera) {
            cameraList.value = editList.off_line_ai_camera.split(",");
          }
          // console.log(258,planBody.file_id,editList.file_id);
          getWaylines(editList.file_id);
          changeDockType();
        } else {
          planBody.name = "";
          planBody.task_type = TaskType.Immediate;
          planBody.select_execute_time = undefined as Moment | undefined;
          planBody.rth_altitude = "";
          planBody.dock_sn = null;
          planBody.wayline_precision_type = 1;
          planBody.out_of_control_action = OutOfControlAction.ReturnToHome;
          planBody.select_execute_date = undefined as [Moment, Moment] | undefined; //执行日期
          planBody.select_execute_date_time = undefined as Moment | undefined; //执行时间
          planBody.select_execute_num = 1; //重复次数
          planBody.select_execute_frequency = "month"; //重复类型
          planBody.remark = ""; //飞行备注
          // planBody.start_off_line_ai = 0; //开启离线AI
          // modelList.value = [];
          // cameraList.value = [];
          dockType.value = false;
          // 连续执行时间
          timeDateConArr.value = [
            {
              stime: undefined as Moment | undefined, //执行时间
              etime: undefined as Moment | undefined, //执行时间
            },
          ];
          // 重复执行 时间
          timeDateArr.value = [
            {
              time: undefined as Moment | undefined, //执行时间
            },
          ];
          // 选中周
          checkWeekDate.value = [];
          // 选中月
          checkMonthDate.value = [];
          if (store) {
            store.commit("SET_SELECT_WAYLINE_INFO", {});
          }
          jobId.value = "";
        }
      },
      { deep: true, immediate: true }
    );
    // 添加执行时间
    function addTimeDate() {
      timeDateArr.value.push({
        time: undefined as Moment | undefined, //执行时间
      });
    }
    // 移出执行时间
    function subTimeDate(index: any) {
      timeDateArr.value.splice(index, 1);
    }
    // 添加连续执行时间
    function addTimeDateCon() {
      timeDateConArr.value.push({
        stime: undefined as Moment | undefined, //执行开始时间
        etime: undefined as Moment | undefined, //执行结束时间
      });
    }
    // 移出连续执行时间
    function subTimeDateCon(index: number) {
      timeDateConArr.value.splice(index, 1);
    }
    // 获取 模型文件
    async function getModelList() {
      let params = {
        workspace: workspaceId,
        current: 1,
        size: -1,
        name: "",
      };
      modelOptions.value = [];
      if (config.layout.aiAllFlag) {
        const res = await getAimodelApi(params);
        if (res.code == 0 && res.data) {
          let arr = [] as any;
          if (res.data.records && res.data.records.length > 0) {
            res.data.records.forEach((item: any) => {
              arr.push({
                label: item.name,
                value: item.path,
              });
            });
          }
          modelOptions.value = arr;
        }
      }
    }
    getMonthDate();
    // 月日期 周日期
    function getMonthDate() {
      for (let i = 1; i <= 31; i++) {
        monthDate.value.push(i);
      }
    }
    // 选中的月日期
    function selectMonthDate(num: number) {
      if (!checkMonthDate.value.includes(num)) {
        checkMonthDate.value.push(num);
      } else {
        checkMonthDate.value.splice(checkMonthDate.value.indexOf(num), 1);
      }
    }
    // 选中的月日期
    function selectWeekDate(num: number) {
      if (!checkWeekDate.value.includes(num)) {
        checkWeekDate.value.push(num);
      } else {
        checkWeekDate.value.splice(checkWeekDate.value.indexOf(num), 1);
      }
    }
    // 获取所有航线
    function getWaylines(val: any) {
      getWaylineFiles(
        workspaceId,
        {
          page: 1,
          page_size: 999,
          order_by: "update_time desc",
        },
        { keyWord: "" }
      ).then((res) => {
        if (res.code !== 0) {
          return;
        }
        if (res.data && res.data.list && res.data.list.length > 0) {
          let obj = {};

          res.data.list.forEach((iten: any) => {
            if (iten.id === val) {
              obj = iten;
            }
          });
          // console.log(264,obj);

          store.commit("SET_SELECT_WAYLINE_INFO", obj);
        }
      });
    }
    // 获取所有设备
    async function getDocks() {
      await getBindingDevices(
        workspaceId,
        { page: 1, total: -1, page_size: 999 },
        EDeviceTypeName.Dock + '',
        { keyWord: "" }
      ).then((res) => {
        if (res.code !== 0) {
          return;
        }
        if (res.data && res.data.list && res.data.list.length > 0) {
          dockList.value = res.data.list;
        }
      });
    }
    // 获取飞行控制参数
    async function getFlyData() {
      const res = await getFlyNum({ sysName: sysType[0].key }, workspaceId);
      const resModel = await getFlyNum(
        { sysName: sysType[6].key },
        workspaceId
      );
      // console.log(93,res);
      if (res.code == 0) {
        if (res?.data?.sys_value) {
          const sysValue = JSON.parse(res?.data?.sys_value);
          const gobackHeifht = sysValue?.gobackHeifht;
          if (gobackHeifht && !planBody.rth_altitude) {
            planBody.rth_altitude = gobackHeifht;
          }
        }
      }
      if (resModel.code == 0) {
        if (resModel?.data?.sys_value) {
          const sysValue = JSON.parse(resModel?.data?.sys_value);
          if (config.layout.aiAllFlag) {
            planBody.start_off_line_ai = sysValue.start_off_line_ai == 1 ? 1 : 0;
          } else {
            planBody.start_off_line_ai = 0;
          }
          cameraList.value = sysValue.cameraList ? sysValue.cameraList : [];
          modelList.value = sysValue.modelList ? sysValue.modelList : [];
          // const gobackHeifht = sysValue?.gobackHeifht;
          // if (gobackHeifht && !planBody.rth_altitude) {
          //   planBody.rth_altitude = gobackHeifht;
          // }
        }
      }
    }
    // 提交
    function onSubmit() {
      valueRef.value
        .validate()
        .then(() => {
          let params = {
            dock_sn: planBody.dock_sn,
            name: planBody.name,
            file_id: planBody.file_id,
            // task_type: TaskType.Immediate,
            // select_execute_time: undefined as Moment | undefined,
            rth_altitude: Number(planBody.rth_altitude),
            out_of_control_action: planBody.out_of_control_action,
            wayline_precision_type: planBody.wayline_precision_type,
            start_off_line_ai: planBody.start_off_line_ai,
            off_line_ai_model: "",
            off_line_ai_camera: "",
            remark: planBody.remark, // 飞行备注
          } as any;
          if (modelList.value && modelList.value.length > 0) {
            params.off_line_ai_model = modelList.value.join(",");
          }
          if (cameraList.value && cameraList.value.length > 0) {
            params.off_line_ai_camera = cameraList.value.join(",");
          }
          // 航线类型
          if (
            wayline.value &&
            wayline.value.template_types &&
            wayline.value.template_types.length > 0
          ) {
            params.wayline_type = wayline.value.template_types[0];
          }
          // 立即执行
          if (planBody.task_type == 0) {
            params.task_type = 0;
          } else if (planBody.task_type == 1) {
            // 单次定时
            params.task_type = 1;
            params.timing_type = 1;
            // 单次定时时间
            if (planBody.select_execute_time) {
              params.execute_time = moment(
                planBody.select_execute_time
              ).valueOf();
            }
          } else if (planBody.task_type == 2) {
            // 重复定时
            params.task_type = 1;
            params.frequency = planBody.select_execute_num;
            // 执行日期
            if (
              planBody.select_execute_date &&
              planBody.select_execute_date.length > 0
            ) {
              params.execution_start = planBody.select_execute_date[0];
              params.execution_end = planBody.select_execute_date[1];
            }
            // 执行时间
            if (timeDateArr.value.length == 0) {
              message.error("请添加执行时间");
              return;
            }
            if (timeDateArr.value && timeDateArr.value.length > 0) {
              let timeArr = [] as any;
              timeDateArr.value.map((item: any) => {
                timeArr.push(item.time);
              });
              let timeStr = timeArr.join(",");
              params.execution_time = timeStr;
            }
            // 月
            if (planBody.select_execute_frequency == "month") {
              params.timing_type = 4;
              if (checkMonthDate.value.length == 0) {
                message.error("请选择日期");
                return;
              }
              if (checkMonthDate.value && checkMonthDate.value.length > 0) {
                params.rules = checkMonthDate.value.join(",");
              }
            } else if (planBody.select_execute_frequency == "week") {
              params.timing_type = 3;
              if (checkWeekDate.value.length == 0) {
                message.error("请选择星期");
                return;
              }
              if (checkWeekDate.value && checkWeekDate.value.length > 0) {
                params.rules = checkWeekDate.value.join(",");
              }
            } else if (planBody.select_execute_frequency == "day") {
              params.timing_type = 2;
            }
          } else if (planBody.task_type == 3) {
            // 连续执行
          }
          disabled.value = true;
          // 存在 即编辑
          if (jobId.value) {
            createPlanEdit(workspaceId, jobId.value, params)
              .then((res) => {
                setTimeout(() => {
                  disabled.value = false;
                  store.commit("SET_SELECT_WAYLINE_INFO", {});
                  message.success("修改成功！");
                  closePlan(true);
                }, 1500);
              })
              .finally(() => {
                // closePlan(true);
              });
          } else {
            createPlan(workspaceId, params)
              .then((res) => {
                if (res.code == 0) {
                  setTimeout(() => {
                    disabled.value = false;
                    store.commit("SET_SELECT_WAYLINE_INFO", {});
                    message.success("新增成功！");
                    closePlan(true);
                  }, 1500);
                } else {
                  message.error(res.message || "新增失败");
                }
              })
              .finally(() => {
                // closePlan(true);
              });
          }
        })
        .catch((e: any) => {
          console.log("validate err", e);
        });
    }
    function closePlan(type = false) {
      planVisible.value = false;
      context.emit("closeplan", type);
    }

    function closePanel(params: any) {
      drawerVisible.value = false;
      routeName.value = "";
      waylinetaskwidth.value = pxToRem(640);
      if (params) {
        const wayline = params.wayline;
        if (wayline && wayline.sn) {
          planBody.dock_sn = wayline.sn;
          changeDockType();
        }
      }
    }

    function selectRoute() {
      drawerVisible.value = true;
      wayVisible.value = true;
      waylinetaskwidth.value = pxToRem(1280);

      // routeName.value = 'WaylinePanelTask'
    }
    return {
      rules,
      planBody,
      selectRoute,
      wayline,
      EDeviceType,
      dock,
      TaskType,
      OutOfControlActionOptions,
      drawerVisible,
      wayVisible,
      closePlan,
      onSubmit,
      disabled,
      closePanel,
      valueRef,
      timeDateArr,
      addTimeDate,
      subTimeDate,
      timeDateConArr,
      addTimeDateCon,
      subTimeDateCon,
      monthDate,
      selectMonthDate,
      checkMonthDate,
      weekDate,
      selectWeekDate,
      checkWeekDate,
      jobId,
      planVisible,
      waylinetaskwidth,
      dockList,
      precisionTypeOption,
      aiLineOption,
      modelOptions,
      cameraList,
      modelList,
      dockType,
      changeDockType,
      config,
    };
  },
});
</script>
<style scoped lang="scss">
// 执行时间
.time-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .time-btn {
    font-size: 18px;
    margin-left: 8px;
    cursor: pointer;

    &:hover {
      color: #2d8cf0;
    }
  }
}

// 重复频率
.frequency-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// 月日期重复规律
.month-date-box {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
  grid-gap: 12px;

  .month-date-item {
    width: 48px;
  }
}

// 月日期 按星期
.month-week-box {
  margin-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.content {
  display: flex;

  &:deep(.ant-form-item-label) {
    width: 100px;
  }

  .infowidth {
    width: 500px;
  }
}

// 工具类
.flex-row {
  display: flex;
}

.text-nowrap {
  white-space: nowrap;
}

.mr-10 {
  margin-right: 10px;
}

.ml-10 {
  margin-left: 10px;
}

.ml-100 {
  margin-left: 100px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-neg-15 {
  margin-top: -15px;
}

.w-full {
  width: 100%;
}

.w-230 {
  width: 230px;
}

.w-300 {
  width: 300px;
}

.w-100 {
  width: 100px;
}

.w-45 {
  width: 45%;
}

.text-ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.text-primary {
  color: #1890ff;
}

.text-dark {
  color: #333;
}

.text-warning {
  color: #f0ab14;
}

.text-disabled {
  color: #5f5f5f;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.p-0 {
  padding: 0;
}

.panel-border {
  padding-top: 5px;
  border: 1px solid #ccc;
}
</style>
<style lang="scss">
.create-plan-wrapper {
  // background-color: #232323;
  color: #3c3c3c;
  padding-bottom: 0;
  // height: 100vh;
  display: flex;
  flex-direction: column;

  .header {
    height: 52px;
    border-bottom: 1px solid #4f4f4f;
    font-weight: 700;
    font-size: 16px;
    padding-left: 10px;
    display: flex;
    align-items: center;
  }

  .content {
    // height: calc(100% - 54px);
    max-height: 600px;

    ::-webkit-scrollbar {
      width: 8px;
      /* 修改滚动条宽度 */
    }

    ::-webkit-scrollbar-thumb {
      background: rgba(181, 187, 196, 0.8);
      /* 修改滚动条滑块的颜色 */
      height: 2px;
    }

    ::-webkit-scrollbar-track {
      background: #fff;
      /* 修改滚动条轨道的颜色 */
    }

    overflow-y: auto;

    form {
      margin: 10px;
    }

    form label,
    input {
      // background-color: #232323;
      color: #333;
    }

    .ant-input-suffix {
      color: #333;
    }

    .ant-form-item {
      margin-bottom: 16px;
    }

    .plan-timer-form-item {
      // flex-direction: column;

      .ant-radio-button-wrapper {
        // background-color: #232323;
        color: #333;

        &.ant-radio-button-wrapper-checked {
          background-color: #1890ff;
          color: #fff;
        }
      }
    }
  }

  .footer {
    display: flex;
    padding: 10px 0;

    button {
      width: 45%;
      // color: #fff ;
      // border: 0;
    }
  }
}

.wayline-panel {
  background: #fff;
  // background: #3c3c3c;
  margin-left: auto;
  margin-right: auto;
  height: 90px;
  width: 100%;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;

  .title {
    display: flex;
    color: #333;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.panel {
  background: #fff;
  margin-left: auto;
  margin-right: auto;
  // margin-top: 10px;
  height: 70px;
  width: 100%;
  font-size: 14px;
  border-radius: 2px;
  cursor: pointer;

  .title {
    display: flex;
    color: #333;
    flex-direction: row;
    align-items: center;
    height: 30px;
    font-weight: bold;
    margin: 0px 10px 0 10px;
  }
}

.selectbtn {
  display: flex;
  width: 100px;
  height: 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 2px;
  border: 1px solid #0085e2;
  background: #f2f8fd;
  cursor: pointer;
}

.prompt {
  display: flex;
  flex: 1;
  height: 32px;
  padding: 0 10px;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  border-radius: 2px;
  border: 1px solid #f0ab14;
  background: #fef6e9;
  margin-right: 10px;
  font-size: 12px;
}

.contentL {
  flex: 1;
}

.contentR {
  width: 50%;
}

.shrink-icons {
  color: #2cd0ab;
  margin: 0 10px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pr10 {
  padding-right: 10px;
}

.ml5 {
  margin-left: 5px;
}

.mt5 {
  margin-top: 5px;
}
</style>